import { useState } from "react";
import { NavDropdown, Collapse } from "react-bootstrap";

import LinkButton from "../linkButton";

import { GoTriangleDown } from "react-icons/go";

import "./menuItemsStyles.css";

const LITEPAPER_URL =
  "https://geopoly-wordpress.s3.us-east-2.amazonaws.com/wp-content/uploads/2021/11/02200940/GEOPOLY_Litepaper_+Nov2021_V1.pdf";
const WHITEPAPER_URL = "https://whitepaper.geopoly.io";

const MenuItems = ({
  isMobile,
  setDisplayBuyGEOTokens,
  setDisplayDownloads,
}) => {
  const [openGame, setOpenGame] = useState(false);
  const [openTokens, setOpenTokens] = useState(false);
  const [openNfts, setOpenNfts] = useState(false);

  const closeAll = () => {
    setOpenGame(false);
    setOpenTokens(false);
    setOpenNfts(false);
  };

  return isMobile ? (
    <>
      <NavDropdown title="GAME" className="header-dropdown mr-2">
        <NavDropdown.Item onClick={() => setDisplayDownloads(true)}>
          DOWNLOADS
        </NavDropdown.Item>
        <NavDropdown.Item
          href={LITEPAPER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          LITEPAPER
        </NavDropdown.Item>
        <NavDropdown.Item
          href={WHITEPAPER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          WHITEPAPER
        </NavDropdown.Item>
        <NavDropdown.Item
          href="/tokenomics"
          target="_blank"
          rel="noopener noreferrer"
        >
          TOKENOMICS
        </NavDropdown.Item>
      </NavDropdown>
      <LinkButton link="/my-assets" text="MY ASSETS" />
      <NavDropdown title="GEO$ TOKEN" className="header-dropdown mr-2">
        <NavDropdown.Item onClick={() => setDisplayBuyGEOTokens(true)}>
          BUY GEO$
        </NavDropdown.Item>
        <NavDropdown.Item href="/staking">GEO$ STAKING</NavDropdown.Item>
        <NavDropdown.Item href="/vesting">CLAIM GEO$</NavDropdown.Item>
      </NavDropdown>
      <LinkButton link="/nft-farming" text="GEOPOLY NFTS" />
      {/* <NavDropdown title="GEOPOLY NFTS" className="header-dropdown mr-2">
        <NavDropdown.Item href="/nft-farming">MY NFTS</NavDropdown.Item>
        <NavDropdown.Item href="/game">MARKETPLACE</NavDropdown.Item>
        <NavDropdown.Item href="/wheel-of-fortune">
          WHEEL OF FORTUNE
        </NavDropdown.Item>
        <NavDropdown.Item href="https://auctions.geopoly.io">
          AUCTIONS
        </NavDropdown.Item>
      </NavDropdown> */}
      <LinkButton link="/about-us" text="ABOUT US" />
      <LinkButton link="/blog" text="BLOG" />
    </>
  ) : (
    <>
      <div className="collapse-menu">
        <button
          onClick={() => {
            closeAll();
            setOpenGame(!openGame);
          }}
          aria-expanded={openGame}
          {...(openGame && { className: "pink" })}
        >
          GAME <GoTriangleDown />
        </button>
        <Collapse in={openGame}>
          <div>
            <button onClick={() => setDisplayDownloads(true)}>DOWNLOADS</button>
            <a href={LITEPAPER_URL} target="_blank" rel="noopener noreferrer">
              LITEPAPER
            </a>
            <a href={WHITEPAPER_URL} target="_blank" rel="noopener noreferrer">
              WHITEPAPER
            </a>
            <a href="/tokenomics" target="_blank" rel="noopener noreferrer">
              TOKENOMICS
            </a>
          </div>
        </Collapse>
      </div>
      <div className="text-right">
        <LinkButton link="/my-assets" text="MY ASSETS" />
      </div>
      <div className="collapse-menu">
        <button
          onClick={() => {
            closeAll();
            setOpenTokens(!openTokens);
          }}
          aria-expanded={openTokens}
          {...(openTokens && { className: "pink" })}
        >
          GEO$ TOKEN <GoTriangleDown />
        </button>
        <Collapse in={openTokens}>
          <div>
            <button onClick={() => setDisplayBuyGEOTokens(true)}>
              BUY GEO$
            </button>
            <a href="/staking" target="_blank" rel="noopener noreferrer">
              GEO$ STAKING
            </a>
            <a href="/vesting" target="_blank" rel="noopener noreferrer">
              CLAIM GEO$
            </a>
          </div>
        </Collapse>
      </div>
      <div className="text-right">
        <LinkButton link="/nft-farming" text="GEOPOLY NFTS" />
      </div>
      {/* <div className="collapse-menu">
        <button
          onClick={() => {
            closeAll();
            setOpenNfts(!openNfts);
          }}
          aria-expanded={openNfts}
          {...(openNfts && { className: "pink" })}
        >
          GEOPOLY NFTS <GoTriangleDown />
        </button>
        <Collapse in={openNfts}>
          <div>
            <a href="/nft-farming" target="_blank" rel="noopener noreferrer">
              MY NFTS
            </a>
            <a href="/game" target="_blank" rel="noopener noreferrer">
              MARKETPLACE
            </a>
            <a
              href="/wheel-of-fortune"
              target="_blank"
              rel="noopener noreferrer"
            >
              WHEEL OF FORTUNE
            </a>
            <a
              href="https://auctions.geopoly.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              AUCTIONS
            </a>
          </div>
        </Collapse>
      </div> */}
      <div className="text-right">
        <LinkButton link="/about-us" text="ABOUT US" />
      </div>
      <div className="text-right">
        <LinkButton link="/blog" text="BLOG" />
      </div>
    </>
  );
};

export default MenuItems;
